module.exports = __webpack_public_path__ + "static/media/germany-flag-round-small.6af1b29f.png";